class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (!this.detailsContainer || !this.summaryToggle) return;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    
    const closeButton = this.querySelector('button[type="button"]');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer && this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    if (!event || !event.target) return;
    event.preventDefault();
    const details = event.target.closest('details');
    if (details) {
      details.hasAttribute('open') ? this.close() : this.open(event);
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || (event.target && event.target.classList && event.target.classList.contains('modal-overlay'))) {
      this.close(false);
    }
  }

  open(event) {
    if (!this.detailsContainer || !event || !event.target) return;
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    const details = event.target.closest('details');
    if (details) {
      details.setAttribute('open', true);
    }
    document.body.addEventListener('click', this.onBodyClickEvent);
    if (document.body.classList) {
      document.body.classList.add('overflow-hidden');
    }

    const tabIndexElement = this.detailsContainer.querySelector('[tabindex="-1"]');
    const inputElement = this.detailsContainer.querySelector('input:not([type="hidden"])');
    if (tabIndexElement || inputElement) {
      trapFocus(tabIndexElement, inputElement);
    }
  }

  close(focusToggle = true) {
    if (!this.detailsContainer) return;
    removeTrapFocus(focusToggle && this.summaryToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    if (this.onBodyClickEvent) {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
    if (document.body.classList) {
      document.body.classList.remove('overflow-hidden');
    }
  }
}

customElements.define('details-modal', DetailsModal);
